import React from "react";
import { config } from "../../../../config";
import ReactQuill from "react-quill"; // Step 2: Import ReactQuill
import "react-quill/dist/quill.snow.css"; // Step 2: Import Quill styles

const UpdateOffer = ({ formData, handleChange, handleSubmit,handleQuillChange, onCancel, loading, error }) => {
  return (
    <div className="p-6 max-w-lg mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Update Offer</h2>

      {/* Display Loading State */}
      {loading && <p className="text-blue-500 mb-4">Updating...</p>}

      {/* Display Error Message */}
      {error && <p className="text-red-500 mb-4">{error}</p>}

      <form onSubmit={handleSubmit}>
        {/* Offer Headline */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Offer Headline</label>
          <input
            type="text"
            name="offerHeadline"
            value={formData.offerHeadline}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter offer headline"
            required
          />
        </div>

        {/* Offer Sub Headline */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Offer Sub Headline</label>
          <input
            type="text"
            name="offerSubHeadline"
            value={formData.offerSubHeadline}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter offer sub headline"
          />
        </div>

        {/* Slug */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Slug</label>
          <input
            type="text"
            name="slug"
            value={formData.slug}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter slug"
          />
        </div>

        {/* Offer Price */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Offer Price</label>
          <input
            type="text"
            name="offerPrice"
            value={formData.offerPrice}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter offer price"
          />
        </div>

        {/* Payment Text */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Payment Text</label>
           <ReactQuill
              value={formData.paymentText}
              onChange={handleQuillChange}
              className="border w-full p-2"
            />
        </div>

        {/* Payment Number */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Payment Number</label>
          <input
            type="text"
            name="paymentNumber"
            value={formData.paymentNumber}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter payment number"
          />
        </div>

         <div className="mb-4">
          <label className="block text-gray-700">Redirect Link</label>
          <input
            type="text"
            name="redirect"
            value={formData.redirect}
            onChange={handleChange}
            className="border w-full p-2"
          />
        </div>

        {/* Button Text */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Button Text</label>
          <input
            type="text"
            name="buttonText"
            value={formData.buttonText}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter button text"
          />
        </div>

        {/* <div className="mb-4">
          <label className="block text-gray-700">Facebook Pixel Id</label>
          <input
            name="pixelId"
            value={formData.pixelId}
            onChange={handleChange}
            className="border w-full p-2"
          />
        </div> */}


        {/* Submit Button */}
          <div className="flex justify-end space-x-3">
             <button
              type="button"
              onClick={onCancel}
              className="bg-gray-500 text-white px-6 py-2 rounded hover:bg-gray-600"
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
              disabled={loading}
            >
              {loading ? "Updating..." : "Update Offer"}
            </button>
          </div>
       
      </form>
    </div>
  );
};

export default UpdateOffer;
